/* istanbul ignore file */

import Vue from "vue";

import toasted from "vue-toasted";
import Fragment from "vue-fragment";

import store from "../store";
import directives from "../directives";
import { mapGetters } from "vuex";

import "../filters";
import "../axios";

import AbilityWrapper from "../components/AbilityWrapper";
import ActionButton from "../components/ActionButton";
import AdultContentSwitcher from "../components/AdultContentSwitcher";
import AdultContentWarning from "../components/AdultContentWarning";
import Alert from "../components/Alert";
import Anchor from "../components/Anchor";
import AsyncForm from "../components/FormsAsyncForm";
import AsyncPaymentModal from "../components/AsyncPaymentModal";
import Autocomplete from "../components/Autocomplete";
import AutocompleteCities from "../components/AutocompleteCities";
import Badge from "../components/Badge";
import BadgeGroup from "../components/BadgeGroup";
import BrandListings from "../components/BrandListings";
import BrandSearch from "../components/BrandSearch";
import ButtonCheckout from "../components/CheckoutButtonCheckout";
import ButtonCheckoutConfirm from "../components/CheckoutButtonCheckoutConfirm";
import CacheableForm from "../components/FormsCacheableForm";
import Carousel from "../components/Carousel";
import CashbackPrice from "../components/CashbackPrice";
import CheckoutAddress from "../components/CheckoutAddress";
import CookieBanner from "../components/CookieBanner";
import CreditCards from "../components/CheckoutPaymentsStripeCreditCards";
import CustomSelect from "../components/CustomSelect";
import DoubleConfirmInput from "../components/DoubleConfirmInput";
import DropZone from "../components/DropZone";
import EssentialsCartOverlay from "../components/EssentialsCartOverlay";
import EssentialsLists from "../components/EssentialsLists";
import EssentialsVendorFilterModal from "../components/EssentialsVendorFilterModal";
import EssentialsVendorFilterSelector from "../components/EssentialsVendorFilterSelector";
import ExpandButton from "../components/ExpandButton";
import FAQItem from "../components/FAQItem";
import FacetWrapper from "../components/FacetWrapper";
import FavoriteVendorsMap from "../components/FavoriteVendorsMap";
import FeatureTable from "../components/FeatureTable";
import FetcherProductShow from "../components/FetcherProductShow";
import FilterGroup from "../components/FilterGroup";
import FilterItem from "../components/FilterItem";
import FilterProductSearch from "../components/FilterProductSearch";
import FilterWrapper from "../components/FilterWrapper";
import FlashMessages from "../components/FlashMessages";
import FormRecaptcha from "../components/FormRecaptcha";
import GenericStripePayment from "../components/CheckoutPaymentsStripeGenericPayment";
import GoogleMapStatic from "../components/GoogleMapStatic";
import GoogleMapStaticParkingWrapper from "../components/GoogleMapStaticParkingWrapper";
import IconTeaser from "../components/IconTeaser";
import IdealoCookieSetter from "../components/IdealoCookieSetter";
import ListWrapper from "../components/CampaignsListWrapper";
import LoginStrategyCredentials from "../components/LoginStrategyCredentials";
import LoginStrategyGuest from "../components/LoginStrategyGuest";
import LunchCheckIn from "../components/LunchCheckIn";
import LunchMenuView from "../components/LunchMenuView";
import ManagementBar from "../components/ManagementBar";
import MobileMenuContent from "../components/MobileMenuContent";
import MobileMenuToggle from "../components/MobileMenuToggle";
import Modal from "../components/Modal";
import OnboardingLoadingOverlay from "../components/OnboardingLoadingOverlay";
import OnboardingSignupForm from "../components/OnboardingSignupForm";
import OtherVendorsModal from "../components/OtherVendorsModal";
import ParkingSpaceList from "../components/ParkingSpaceList";
import ParkingSpaceListItem from "../components/ParkingSpaceListItem";
import ParkingSpaceView from "../components/ParkingSpaceView";
import PasswordStrengthMeter from "../components/PasswordStrengthMeter";
import PaymentButtonWrapper from "../components/CheckoutPaymentButtonWrapper";
import PaymentWrapper from "../components/CheckoutPaymentWrapper";
import PaymentsWrapper from "../components/CheckoutPaymentsWrapper";
import PortalVue from "portal-vue";
import PricingToggler from "../components/PricingToggler";
import ProductEssentialItem from "../components/ProductEssentialItem";
import ProductGallery from "../components/ProductGallery";
import ProductHiddenField from "../components/VariantPickerProductHiddenField";
import ProductNameFilterInput from "../components/CampaignsProductNameFilterInput";
import ProductQuickEditButtons from "../components/ProductQuickEditButtons";
import ProductTile from "../components/ProductTile";
import ProductTileWrapper from "../components/ProductTileWrapper";
import ReadMore from "../components/ReadMore";
import SavingsBadge from "../components/ProductSavingsBadge";
import ScriptLoaderGoogleAnalytics from "../components/externalScripts/ScriptLoaderGoogleAnalytics";
import ScriptLoaderHotjar from "../components/externalScripts/ScriptLoaderHotjar";
import ScriptLoaderLiveBuy from "../components/externalScripts/ScriptLoaderLiveBuy";
import ScriptLoaderPaypalPlus from "../components/externalScripts/ScriptLoaderPayPalPlus";
import ScriptLoaderStripe from "../components/externalScripts/ScriptLoaderStripe";
import ScriptLoaderVideo from "../components/externalScripts/ScriptLoaderVideo";
import SearchbarAutocomplete from "../components/SearchbarAutocomplete";
import SelectRedirect from "../components/SelectRedirect";
import ServiceTile from "../components/ServiceTile";
import ShoppingCartButton from "../components/ShoppingCartButton";
import ShoppingCartOverlay from "../components/ShoppingCartOverlay";
import ShoppingListModalContent from "../components/ShoppingListModalContent";
import ShoppingListVisibilityWrapper from "../components/ShoppingListVisibilityWrapper";
import ShoppingList_Cart from "../components/ShoppingListCart";
import ShoppingList_Item from "../components/ShoppingListItem";
import SocialSharing from "vue-social-sharing";
import SubmitButton from "../components/VariantPickerSubmitButton";
import Swiper from "../components/Swiper";
import TabContent from "../components/TabContent";
import TabContentWrapper from "../components/TabContentWrapper";
import TabNav from "../components/TabNav";
import TabNavItem from "../components/TabNavItem";
import TaxonGroup from "../components/TaxonGroup";
import TaxonItem from "../components/TaxonItem";
import TicketStore from "../components/TicketStore";
import Toggler from "../components/Toggler";
import UserFormEmailField from "../components/UserFormEmailField";
import UserFormSubmitButton from "../components/UserFormSubmitButton";
import VariantPicker from "../components/VariantPicker";
import VariantPickerAlerts from "../components/VariantPickerAlerts";
import VariantPrice from "../components/VariantPrice";
import VendorIntroButton from "../components/VendorIntroButton";
import VendorIntroVideo from "../components/VendorIntroVideo";
import VendorList from "../components/VendorList";
import VendorLocation from "../components/VendorLocation";
import VendorNavigation from "../components/VendorNavigation";
import VendorTile from "../components/VendorTile";
import VendorTileHorizontal from "../components/VendorTileHorizontal";
import VendorsMap from "../components/VendorsMap";
import VendorsMapSearch from "../components/VendorsMapSearch";
import VimeoIframe from "../components/VimeoIframe";
import VoucherCodeInput from "../components/CheckoutVoucherCodeInput";
import VoucherVendorList from "../components/VoucherVendorList";
import WishlistButton from "../components/WishlistButton";
import YoutubeIframe from "../components/YoutubeIframe";
import Zoomer from "../components/Zoomer";

const vueEl = "[data-vue-global='frontend']";

Vue.directive("open-modal", directives.openModal);
Vue.directive("close-modal", directives.closeModal);
Vue.directive("toggle", directives.toggle);

const currentCityElement = document.querySelector("[data-current-city]");
const currentLocaleElement = document.querySelector("[data-current-locale]");

document.ready.then(() => {
  Vue.use(toasted, {
    containerClass: "ata-toast",
    iconPack: "fontawesome",
    duration: 5000,
  });

  Vue.use(Fragment.Plugin);
  Vue.use(SocialSharing);
  Vue.use(PortalVue);

  if (document.querySelector(vueEl)) {
    if (currentCityElement) {
      store.dispatch("setCurrentCityUrl", currentCityElement.getAttribute("data-current-city"));
    }
    if (currentLocaleElement) {
      store.dispatch("setCurrentLocale", currentLocaleElement.getAttribute("data-current-locale"));
    }
    document.querySelectorAll(vueEl).forEach(element => {
      new Vue({
        el: element,
        store,
        name: "Frontend",
        components: {
          "ability-wrapper": AbilityWrapper,
          "action-button": ActionButton,
          "adult-content-switcher": AdultContentSwitcher,
          "adult-content-warning": AdultContentWarning,
          "async-form": AsyncForm,
          "async-payment-modal": AsyncPaymentModal,
          "autocomplete-cities": AutocompleteCities,
          "badge-group": BadgeGroup,
          "brand-listings": BrandListings,
          "brand-search": BrandSearch,
          "button-checkout": ButtonCheckout,
          "button-checkout-confirm": ButtonCheckoutConfirm,
          "cacheable-form": CacheableForm,
          "checkout-address": CheckoutAddress,
          "cookie-banner": CookieBanner,
          "custom-select": CustomSelect,
          "double-confirm-input": DoubleConfirmInput,
          "drop-zone": DropZone,
          "essentials-cart-overlay": EssentialsCartOverlay,
          "essentials-lists": EssentialsLists,
          "essentials-vendor-filter-modal": EssentialsVendorFilterModal,
          "essentials-vendor-filter-selector": EssentialsVendorFilterSelector,
          "expand-button": ExpandButton,
          "facet-wrapper": FacetWrapper,
          "faq-item": FAQItem,
          "favorite-vendors-map": FavoriteVendorsMap,
          "feature-table": FeatureTable,
          "fetcher-product-show": FetcherProductShow,
          "filter-group": FilterGroup,
          "filter-item": FilterItem,
          "filter-product-search": FilterProductSearch,
          "filter-wrapper": FilterWrapper,
          "flash-messages": FlashMessages,
          "form-recaptcha": FormRecaptcha,
          "google-map-static": GoogleMapStatic,
          "google-map-static-parking-wrapper": GoogleMapStaticParkingWrapper,
          "icon-teaser": IconTeaser,
          "idealo-cookie-setter": IdealoCookieSetter,
          "list-wrapper": ListWrapper,
          "login-strategy-credentials": LoginStrategyCredentials,
          "login-strategy-guest": LoginStrategyGuest,
          "lunch-check-in": LunchCheckIn,
          "lunch-menu-view": LunchMenuView,
          "management-bar": ManagementBar,
          "mobile-menu-content": MobileMenuContent,
          "mobile-menu-toggle": MobileMenuToggle,
          "onboarding-loading-overlay": OnboardingLoadingOverlay,
          "onboarding-signup-form": OnboardingSignupForm,
          "other-vendors-modal": OtherVendorsModal,
          "parking-space-list": ParkingSpaceList,
          "parking-space-list-item": ParkingSpaceListItem,
          "parking-space-view": ParkingSpaceView,
          "password-strength-meter": PasswordStrengthMeter,
          "payment-button-wrapper": PaymentButtonWrapper,
          "payment-credit-card": CreditCards,
          "payment-stripe-generic": GenericStripePayment,
          "payment-wrapper": PaymentWrapper,
          "payments-wrapper": PaymentsWrapper,
          "pricing-toggler": PricingToggler,
          "product-essential-item": ProductEssentialItem,
          "product-name-filter-input": ProductNameFilterInput,
          "product-quick-edit-buttons": ProductQuickEditButtons,
          "product-tile": ProductTile,
          "product-tile-wrapper": ProductTileWrapper,
          "read-more": ReadMore,
          "script-loader-google-analytics": ScriptLoaderGoogleAnalytics,
          "script-loader-hotjar": ScriptLoaderHotjar,
          "script-loader-live-buy": ScriptLoaderLiveBuy,
          "script-loader-paypal-plus": ScriptLoaderPaypalPlus,
          "script-loader-stripe": ScriptLoaderStripe,
          "script-loader-video": ScriptLoaderVideo,
          "searchbar-autocomplete": SearchbarAutocomplete,
          "select-redirect": SelectRedirect,
          "service-tile": ServiceTile,
          "shopping-cart-button": ShoppingCartButton,
          "shopping-cart-overlay": ShoppingCartOverlay,
          "shopping-list-modal-content": ShoppingListModalContent,
          "shopping-list-visibility-wrapper": ShoppingListVisibilityWrapper,
          "store-cashback-price": CashbackPrice,
          "store-product-gallery": ProductGallery,
          "store-product-hidden-field": ProductHiddenField,
          "store-savings-badge": SavingsBadge,
          "store-shopping-list-cart": ShoppingList_Cart,
          "store-shopping-list-item": ShoppingList_Item,
          "store-submit-button": SubmitButton,
          "store-swiper": Swiper,
          "store-variant-picker": VariantPicker,
          "store-variant-picker-alerts": VariantPickerAlerts,
          "store-variant-price": VariantPrice,
          "store-vendor-intro-button": VendorIntroButton,
          "store-vendor-intro-video": VendorIntroVideo,
          "store-zoomer": Zoomer,
          "tab-content": TabContent,
          "tab-content-wrapper": TabContentWrapper,
          "tab-nav": TabNav,
          "tab-nav-item": TabNavItem,
          "taxon-group": TaxonGroup,
          "taxon-item": TaxonItem,
          "ticket-store": TicketStore,
          "user-form-email-field": UserFormEmailField,
          "user-form-submit-button": UserFormSubmitButton,
          "vendor-list": VendorList,
          "vendor-location": VendorLocation,
          "vendor-navigation": VendorNavigation,
          "vendor-tile": VendorTile,
          "vendor-tile-horizontal": VendorTileHorizontal,
          "vendors-map": VendorsMap,
          "vendors-map-search": VendorsMapSearch,
          "vimeo-iframe": VimeoIframe,
          "voucher-code-input": VoucherCodeInput,
          "voucher-vendor-list": VoucherVendorList,
          "youtube-iframe": YoutubeIframe,
          "wishlist-button": WishlistButton,
          alert: Alert,
          anchor: Anchor,
          autocomplete: Autocomplete,
          badge: Badge,
          carousel: Carousel,
          modal: Modal,
          toggler: Toggler,
        },
        computed: {
          ...mapGetters({ toggles: "getGlobalToggles" }),
        },
        mounted() {
          window._lytics_.attachEventListeners(this.$el);
        },
      });
    });
  }
});
